import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { Question } from '@/features/survey/survey-types'
import { usePickByLanguage } from '@/hooks/use-pick-by-language'
import { getCardStyle, containerStyle, inputStyle } from './survey-choice-styles'
import { useAppSelector } from '@/app/hooks'
import { useTranslation } from 'react-i18next'
import { ErrorMessage } from '@/components/atoms/error-message'

type Props = {
  question: Question
  index: number
}

export const SurveyChoiceSingleForm = ({ question, index }: Props) => {
  const pickByLanguage = usePickByLanguage()
  const { register, formState: { errors } } = useFormContext()
  const { t } = useTranslation()
  const design = useAppSelector(state => state.design)

  // エラーメッセージの取得
  const errorMessage = errors.answers?.[index]?.answerText?.message as string | undefined

  const cardStyle = useMemo(
    () => getCardStyle(design),
    [design],
  )

  return (
    <>
      <div css={containerStyle}>
        {question.choices?.map((choice, choiceIndex) => (
          <label key={choiceIndex} css={cardStyle}>
            <input
              type="radio"
              {...register(`answers.${index}.answerText`, {
                required: question.isRequired ? t('This field is required') : false
              })}
              value={pickByLanguage(choice)}
              css={inputStyle}
            />
            <span>
              {pickByLanguage(choice)}
            </span>
          </label>
        ))}
      </div>
      {errorMessage && <ErrorMessage text={errorMessage} />}
    </>
  )
}


